angular.module('angus.controllers').controller('subRegHierarchyController', [
    '$scope', '$http', '$q', 'hierarchyService', 'modalService', 'settingsViews', 'actionViewTemplates', 'constantsService', '_', 'fluentRest', 'promiseMonitor', 'alertsService',
    function($scope, $http, $q, hierarchyService, modalService, settingsViews, actionViewTemplates, constants, _, fluentRest, PromiseMonitor, AlertsService) {

        'use strict';

        var vm = this;

        vm.subscriber = $scope.$parent.$parent.subscriber; // This is bad but I want to do the controllerAs

        vm.alerts = new AlertsService();


        function getAccess() {
            return $http
                .get('/access')
                .success(function() {
                // .success(function(access) {
                    vm.hasAccess = true; //access.role == constants.roles.sysadmin;
                    return vm.hasAccess;
                });
        }

        function boldQuotes(str){
            var startsWithQuote = str.charAt(0) == '\"';

            function boldIt(substring){
                return '<strong>' + substring + '</strong>';
            }

            var arr = str.split('\"');

            if(startsWithQuote) arr.splice(0, 1);

            return _.reduce(arr, function(result, substring, index){
                var mod = (index % 2) === 0;
                if(mod == startsWithQuote)
                    result += boldIt(substring)
                else
                    result += substring;

                return result;
            },'');

        }

        function mapBoldQuotes(strs){
            return _.map(strs, function(str){ return boldQuotes(str); })
        }


        vm.isHierarchySyncing = false;
        vm.syncHierarchy = function() { 
            vm.isHierarchySyncing = true;
            return $http.get(('api/subscribers/{0}/hierarchy/nodes/sync?preserve=1').format(vm.subscriber.id))
                .then(function() {
                    init();
                }, function(error) {
                    vm.alerts.addError('Unable to synchronize hierarchy: ' +
                        (error.data && error.data.message || 'the server returned an error.'));
                })
                .finally(function() {
                    vm.isHierarchySyncing = false;
                }); 
        };

        vm.getTMSContacts = function(requery){
            if(vm.tmsContacts && !requery) return $q.when();

            return   $http({
                method: 'GET',
                url   : '/api/subscribers/{0}/tmsContacts'.format($scope.subscriberId),                
                params : { allDealers : true }
            })
            .then(function(result){ 
              vm.tmsContacts = result.data;
            });
        };

        vm.getTMSContactForNode = function(node){
            if (node.isRoot) {
                return _.find(vm.tmsContacts, function(contact) {
                    return !contact.dealerId
                })
            }

            return _.find(vm.tmsContacts, function(contact){
                return contact.dealerId == node.id;
            });            
        };

        vm.openTMSContactModal = function(node, contact){      
           var scope = {
              contact         : contact ? _.cloneDeep(contact) : {},        
              subscriberName  : $scope.subscriber.name,
          };

          modalService
            .openTopBarModal(actionViewTemplates.subRegEditTMSContact, scope)
            .then(function(contact){          
                if(!contact) return;

                if (!node.isRoot) {
                    contact.dealerId = node.id;
                }
                
                var promise =   $http({
                    method: 'PUT',
                    url   : '/api/subscribers/{0}/tmsContacts'.format($scope.subscriberId),
                    data  : contact
                })
                .then(function(){ 
                    vm.tmsContact = contact;
                    return vm.getTMSContacts(true);                    
                });
                
                $scope.tmsContactMonitor = new PromiseMonitor(promise);
            });
        };


        function HierarchyType(key, display){
            var that = this;

            that.key            = key;
            that.display        = display;

            that.showSuppressed = false;
            that.showUsers      = true;
            that.showBudgets    = true;
            that.showTypes      = true;

            that.selectedNodes  = [];
            that.leafSelected   = false;
            that.rootSelected   = false;

            that.batchPromises = new PromiseMonitor();
            that.promiseMonitor = new PromiseMonitor();

            that.isDealer = that.key == constants.hierarchyType.dealer.key;

            function getSqlLevels(){
                var hierarchyTypeKey = {
                    division: 1,
                    deliveryCenter: 2,
                    serviceCenter: 3,
                    dealer: 4
                }[that.key];

                return $http.get('api/subscriber/' + vm.subscriber.abosKey + '/hierarchy-node-levels', {
                    apiV2: true,
                    params: { hierarchyType: hierarchyTypeKey }
                }).then(function(response){
                    return response.data;
                });
            }

            that.init = function(){
                var promises = [vm.activeHierarchyType.getNodes()];

                if(that.isDealer){
                    promises.push(vm.getTMSContacts());   
                }                  

                var promise = $q.all(promises);
                that.promiseMonitor.monitor(promise);
                return promise;
            }


            that.nodeSelected = function(node, selected) {
                node.willBeOrphaned = node.originalParent == that.currentNode.id && !selected;
            };

            function getFilter(){
                var filter =  {
                    hierarchyType  : that.key,
                    showSuppressed :  that.showSuppressed ? 1 : undefined,
                    showUsers :  that.showUsers ? 1 : undefined,
                    showWithoutChildren : true
                };

                if(that.key == 'division' && that.showBudgets)
                    filter.showBudgets =  that.showBudgets ? 1 : undefined;

                return filter;
            }


            function saveNode(id, postData){
                //nodeIdToUseForSettings
                var endpoint = fluentRest.api().subscribers(vm.subscriber.id).hierarchy().nodes(id);

                var promise = id ? endpoint.put(postData, getFilter()) : endpoint.post(postData, getFilter());

                return promise
                    .then(function(data){
                            if(data.messages.success && data.messages.success.length > 0)
                                vm.alerts.addSuccess(((id ? 'Updated' : 'Inserted') + ' node.'), mapBoldQuotes(data.messages.success));
                            that.getNodes();
                            that.cancelEdit();
                        })
                        .catch(function(err){
                            vm.alerts.addError(boldQuotes(err));
                        });
            }


            function CurrentNode(node){
                var currentNode = this;

                currentNode.promises = new PromiseMonitor();

                _.assign(currentNode, node);

                function getData(){
                    var data = {
                        parent : currentNode.parent,
                        children : _.map(currentNode.children, 'id'),
                        name     : currentNode.name
                    };

                    if(that.isDealer) data.amsDealerFlag = !!currentNode.amsDealerFlag;
                    if(currentNode.hierarchyNodeLevelKey != null)
                        data.hierarchyNodeLevelKey = currentNode.hierarchyNodeLevelKey;

                    return data;
                }

                currentNode.save = function(){
                    var promise = saveNode(currentNode.id, getData());
                    that.currentNode.promises.monitor(promise);
                    return promise;
                };

                return currentNode;
            }

            function mapNodes(nodes){
                that.nodes = hierarchyService.convertDataForEaseOfUse(nodes);

                var rootNode = _.find(that.nodes, function(node){ return node.isRoot; });
                var dealerLevelNames = {
                    1: 'Company',
                    2: 'Dealer',
                    5: 'Division'
                };

                function convert(node, hierarchyName){

                    hierarchyName = hierarchyName ? (hierarchyName + ':)' +  node.name) : node.name;

                    var data = {
                        name                    : node.name,
                        id                      : node.id,
                        originalParent          : node.parents[0] ? node.parents[0].id : null,
                        isRoot                  : node.isRoot,
                        isLeaf                  : node.isLeaf,
                        isSuppressed            : node.isSuppressed,
                        innerNodeWithNoChildren : node.innerNodeWithNoChildren,
                        hierarchyName           : hierarchyName,
                        numberOfUsers           : node.numberOfUsers,
                        numberOfBudgets         : node.numberOfBudgets,
                        type                    : node.type,
                        levelDisplayName        : that.isDealer && node.type
                            ? dealerLevelNames[node.type.sequence] || node.type.name
                            : node.type && node.type.name
                    };

                    if(that.isDealer){
                        data.isInDealerHierarchy = node.isInDealerHierarchy;
                        data.isDealer = node.isDealer;
                        data.amsDealerFlag = !!node.amsDealerFlag;
                    }

                    if(node.children) data.children = _.map(node.children, function(child){ return convert(child, hierarchyName); });
                    data.children = _.sortBy(data.children, 'name')
                    return data;
                }


                function getAllNodesInTree(nodes){
                    return _.reduce(nodes, function(result, node){
                        result.push(node);
                        var descendants = getAllNodesInTree(node.children);
                        result = result.concat(descendants);
                        return result;
                    },[])
                }

                that.treeViewNodes         = [convert(rootNode)];
                that.treeViewNodesExpanded = getAllNodesInTree(that.treeViewNodes);

                that.childrenTreeVieNodes         = _.cloneDeep(that.treeViewNodes[0].children);
                that.childrenTreeVieNodesExpanded = getAllNodesInTree(that.childrenTreeVieNodes);
            }



            function getSelectedNodeIds(){ return _.map(that.selectedNodes, 'id'); }

            function nodeSuppression(suppress){
                var postData = {
                    nodeIds    : getSelectedNodeIds(),
                    suppress   : suppress
                };

                var word = postData.suppress ? 'Suppress' : 'Unsupress';

                var promise = fluentRest
                    .api()
                    .subscribers(vm.subscriber.id)
                    .hierarchy()
                    .nodes()
                    .suppress()
                    .put(postData, getFilter())
                        .then(function(data){
                            if(data.messages.success && data.messages.success.length > 0)
                                vm.alerts.addSuccess((word + 'ed nodes.'), mapBoldQuotes(data.messages.success));

                            if(data.messages.failure && data.messages.failure.length > 0)
                                vm.alerts.addError('Unable to ' + word.toLowerCase() + ' nodes.', mapBoldQuotes(data.messages.failure));

                            mapNodes(data.nodes);
                            that.selectedNodes = [];
                        })
                        .catch(function(err){
                            vm.alerts.addError(boldQuotes(err));
                        });

                that.batchPromises.monitor(promise);

                return promise;
            }

            that.anyUnsuppressableSelected = function(){
                return _.some(that.selectedNodes, function(node){
                    return !node.isSuppressed && !node.isRoot;
                });
            };
            that.anySuppressableSelected = function(){
                return _.some(that.selectedNodes, function(node){
                    return node.isSuppressed;
                });
            };
            that.anyNotRootSelected = function(){
                return _.some(that.selectedNodes, function(node){
                    return !node.isRoot;
                });
            };

            that.anyNotLeafSelected = function(){
                return _.some(that.selectedNodes, function(node){
                    return !node.isLeaf;
                });
            };

            that.getNodes = function(){
                that.selectedNodes = [];

                var nodePromise = fluentRest
                    .api()
                    .subscribers(vm.subscriber.id)
                    .hierarchy()
                    .nodes()
                    .panel()
                    .get(getFilter());

                var promise = $q.all([
                    nodePromise,
                    getSqlLevels()
                ]).then(function(results){
                    var nodes = results[0];
                    var levels = results[1];

                    that.nodeLevelSelections = _.sortBy(_.filter(levels, function(level){
                        return level.hierarchyNodeLevelSequence >= 2 && level.hierarchyNodeLevelSequence <= 4;
                    }), 'hierarchyNodeLevelSequence');

                    mapNodes(nodes);
                });

                that.promiseMonitor.monitor(promise);

                return promise;
            };
            
            that.suppressNodes = function(){
                return nodeSuppression(true);
            };

            that.unSuppressNodes = function(){
                return nodeSuppression(false);
            };

            that.cancelEdit = function(){
                delete that.currentNode;
            };

            that.addNewNode = function() {
                that.selectedNodes = [];
                var newNode = {
                    name : null,
                    isSuppressed : false,
                    children : []
                };
                vm.alerts.clearAll();
                that.currentNode = new CurrentNode(newNode);

            };

            that.editNode = function(node){
                that.selectedNodes = [];
                var nodeWithAllProps = _.find(this.nodes, function(potentialNode){ return potentialNode.id == node.id; });

                if(!nodeWithAllProps) return;

                var editNode = _.cloneDeep(nodeWithAllProps);

                if(!nodeWithAllProps.isRoot) editNode.parent = nodeWithAllProps.parents[0].id;

                if(that.isDealer) editNode.amsDealerFlag = nodeWithAllProps.amsDealerFlag;


                function getChildren(nodes, nodeId){
                    var children = _.reduce(nodes, function(result, node){
                        if(node.id == nodeId) result =  node.children;
                        else {
                            var children = getChildren(node.children, nodeId);
                            if(children.length> 0) result = children;
                        }

                        return result;
                    },[]);

                    return children;
                }

                if(!nodeWithAllProps.isLeaf)
                    editNode.children = nodeWithAllProps.isRoot ? _.cloneDeep(that.childrenTreeVieNodes) : _.cloneDeep(getChildren(that.childrenTreeVieNodes, editNode.id));

                vm.alerts.clearAll();
                that.currentNode = new CurrentNode(editNode);
            };

            that.editLevelNames = function(){
                if(that.isDealer) return;

                return getSqlLevels().then(function(levels){
                    var originalOverrides = {};
                    _.forEach(levels, function(level){
                        originalOverrides[level.hierarchyNodeLevelKey] = (level.overrideHierarchyNodeLevelName || '').trim();
                    });

                    return modalService.openTopBarModal(actionViewTemplates.subRegEditHierarchyLevelNames, {
                        hierarchyTypeName: that.display,
                        levels: _.sortBy(levels, 'hierarchyNodeLevelSequence'),
                        alerts: new AlertsService(),
                        saving: false,
                        saveLevels: function(){
                            var modal = this;
                            var updates = _.reduce(modal.levels, function(changes, level){
                                var name = (level.overrideHierarchyNodeLevelName || '').trim();
                                if(name !== originalOverrides[level.hierarchyNodeLevelKey]){
                                    changes.push({
                                        hierarchyNodeLevelKey: level.hierarchyNodeLevelKey,
                                        overrideHierarchyNodeLevelName: name || null
                                    });
                                }
                                return changes;
                            }, []);

                            if(!updates.length){
                                modal.close();
                                return;
                            }

                            modal.saving = true;
                            return $http.put('api/subscriber/' + vm.subscriber.abosKey + '/hierarchy-node-levels/overrides', updates, {
                                apiV2: true
                            }).then(function(){
                                modal.close(true);
                                vm.alerts.addSuccess('Hierarchy level names updated.');
                                that.getNodes().catch(function(){
                                    vm.alerts.addError('Unable to refresh the hierarchy after saving level names.');
                                });
                            }, function(){
                                modal.alerts.addError('Unable to save hierarchy level names.');
                            }).finally(function(){
                                modal.saving = false;
                            });
                        }
                    });
                }).catch(function(){
                    vm.alerts.addError('Unable to load hierarchy levels from SQL.');
                });
            };
        }

        $scope.switchHierarchyType = function(){
            return vm.activeHierarchyType.init();
        }



        function init() {
            vm.promiseMonitor = new PromiseMonitor();

            vm.treeControlOptions = {
                multiSelection  : true, templateUrl:
                actionViewTemplates.subRegHierarchyTreeControl,
                isSelectable: function() {
                    return !vm.activeHierarchyType.promiseMonitor.isPending();
                }, injectClasses : {
                    'iExpanded': 'fa-minus-square-o',
                    'iCollapsed': 'fa-plus-square-o',
                }
            };

            vm.formTreeControlOptions = {
                multiSelection  : true, templateUrl:
                actionViewTemplates.subRegHierarchyTreeControl,
                isSelectable: function() {
                    return vm.activeHierarchyType.currentNode && !vm.activeHierarchyType.currentNode.promises.isPending();
                }, injectClasses : {
                    'iExpanded': 'fa-minus-square-o',
                    'iCollapsed': 'fa-plus-square-o',
                }
            };

            var promise = getAccess()
                .then(function(hasAccess){

                    vm.hierarchyTypes = _.reduce(constants.hierarchyType.enums, function(result, type){
                            if(type.key != constants.hierarchyType.dealer.key || (vm.subscriber.isPaygo && hasAccess))
                                result.push(new HierarchyType(type.key, type.value.display));
                            return result;
                        }, []);

                    vm.activeHierarchyType = vm.hierarchyTypes[0];
                    return vm.activeHierarchyType.init();
                });

            vm.promiseMonitor.monitor(promise);
        }

        init();
    }
]);
